import { useEffect, useState } from "react";
import { SETTINGS_URL } from "../../api/AdminUrls";
import { get, post } from "../../services/smartApiService";
import "./Settings.scss";
import SiteSettings from "./SiteSettings";
import { useSiteContext } from "../../contexts/SiteProvider";
import ExamSettings from "./ExamSettings";


const Settings: React.FC = () => {
  const [tab, setTab] = useState("site");
  const [_data, setData] = useState<any>();

  // const { setTitle} = useSiteContext();
  useEffect(() => {
   
    // setTitle("Site Settings");
  }, []);
  const tabs = [
    { label: "Site Settings", icon: "fa-gears", index: "site" },

    // {
    //   label: "Leave And Attendance Settings",
    //   icon: "fa-share",
    //   index: "leave",
    // },
    // { label: "Examination Settings", icon: "fa-pencil", index: "exam" },
    // { label: "Message And Title Settings", icon: "fa-envelope-o", index: "massage" },
  ];

  const LoadData = () => {
    const subscription = get(SETTINGS_URL.GET_ALL).subscribe(
      (response) => {
        setData(response.data);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const saveSettings = (data_in: any) => {
    const subscription = post(SETTINGS_URL.INSERT, data_in).subscribe(
      (response) => {
        LoadData();
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    LoadData();
  }, []);



  const tabsDisplay = () => {
    return (
      <div className="">
      <div className="tabs is-toggle is-small">
        <ul>
          {tabs.map((item) => {
            return (
              <li
                className={`${tab == item.index ? "is-active" : ""}`}
                onClick={() => setTab(item.index)}
              >
                <a>
                  <span className="icon is-small">
                    <i className={`fa ${item.icon}`} aria-hidden="true"></i>
                  </span>
                  <span>{item.label}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
      </div>
    );
  };

  const displayContent = () => {
    switch (tab) {
      case "site":
        return <SiteSettings saveSettings={saveSettings} dataIn={_data} />;
   
      // case "exam":
        // return <ExamSettings dataIn={_data} saveSettings={saveSettings} />;
      // case "massage":
      //   return <TitleAndMassageSettings dataIn={_data} saveSettings={saveSettings} />;
    }
  };

  return (
    <div className="settings-wrapper">
      {tabsDisplay()}
      {_data && <div className="settings-content">{displayContent()}</div>}
    </div>
  );
};

export default Settings;
